import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ScreeningProvider } from './context/ScreeningContext'
import { useAuth } from './context/AuthContext'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import ScreeningWizard from './pages/ScreeningWizard'
import ResultsPage from './pages/ResultsPage'
import Settings from './pages/Settings'
import { useEffect, useState } from 'react'
import './index.css'

// Composant de protection des routes
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white">Chargement...</p>
        </div>
      </div>
    )
  }
  
  return user ? children : <Navigate to="/login" replace />
}

// Composant principal
function AppContent() {
  const { user, loading } = useAuth()
  const [servicesReady, setServicesReady] = useState(false)

  useEffect(() => {
    const initServices = async () => {
      try {
        console.log('🔧 Initialisation des services...')
        
        // Attendre que les services soient chargés
        let attempts = 0
        while ((!window.supabaseAuth || !window.claudeAPI) && attempts < 50) {
          await new Promise(resolve => setTimeout(resolve, 100))
          attempts++
        }
        
        console.log('✅ Services prêts')
        setServicesReady(true)
        
      } catch (error) {
        console.error('❌ Erreur init services:', error)
        setServicesReady(true) // Continuer même en cas d'erreur
      }
    }
    
    initServices()
  }, [])

  if (!servicesReady && !loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white">Chargement des services...</p>
        </div>
      </div>
    )
  }

  return (
    <Router>
      <div className="app-container">
        <Routes>
          {/* Routes publiques */}
          <Route path="/login" element={
            user ? <Navigate to="/" replace /> : <Login />
          } />
          
          {/* Routes protégées */}
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/screening" element={
            <ProtectedRoute>
              <ScreeningWizard />
            </ProtectedRoute>
          } />
          
          <Route path="/results" element={
            <ProtectedRoute>
              <ResultsPage />
            </ProtectedRoute>
          } />
          
          <Route path="/settings" element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          } />
         
          {/* Redirection par défaut */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  )
}
   
function App() {
  return (
    <AuthProvider>
      <ScreeningProvider>
        <AppContent />
      </ScreeningProvider>
    </AuthProvider>
  )
}
   
export default App